import React from "react";
import { Checkbox } from "antd";
import "./style.css";

const CheckboxGroup = ({ options, ...restProps }, ref) => {
  return (
    <div className="custom-checkbox-buttons">
      <Checkbox.Group options={options} ref={ref} {...restProps} />
    </div>
  );
};

export default React.forwardRef(CheckboxGroup);